export default __webpack_public_path__ + "static/media/best_DEX_Hero.34b1601c.svg";